import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper";
import SliderItem from "./slider_item";

import { Theme } from "../../pages";
import { useRouter } from "next/router";

interface IProp {
  title: string;
  themes: Theme[];
  loading: boolean;
}
const PopularTheme = (props: IProp) => {
  const router = useRouter();
  return (
    <div className="block w-full">
      <div className="flex justify-between border-t py-4">
        <h2 className="font-extrabold text-xl">{props.title}</h2>
      </div>

      <div>
        <Swiper
          slidesPerView={5}
          spaceBetween={10}
          slidesPerGroup={5}
          loop={false}
          loopFillGroupWithBlank={false}
          pagination={{
            clickable: true,
          }}
          breakpoints={{
            320: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: 0,
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              spaceBetween: 10,
            },

            640: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 4,
              slidesPerGroup: 4,
              spaceBetween: 10,
            },
            1024: {
              slidesPerView: 5,
              slidesPerGroup: 5,
              spaceBetween: 10,
            },
          }}
          navigation={true}
          modules={[Pagination, Navigation]}
          className="w-full h-[140px] mb-6"
        >
          {props.themes.length > 0
            ? props.themes.map((theme, index) => {
                return (
                  <SwiperSlide key={index}>
                    <SliderItem
                      category={props.title}
                      title={
                        router.locale == "en"
                          ? theme.theme.title_en
                          : theme.theme.title_ko
                      }
                      url={theme.theme.url}
                      image={theme.image}
                    />
                  </SwiperSlide>
                );
              })
            : Array(5)
                .fill(0)
                .map((v, i) => (
                  <SwiperSlide key={i}>
                    <div className="w-full h-full bg-gray-200 animate-pulse rounded transition ease-in-out delay-150"></div>
                  </SwiperSlide>
                ))}
        </Swiper>
      </div>
    </div>
  );
};

export default PopularTheme;
